import { render, staticRenderFns } from "./order-pack.vue?vue&type=template&id=97304470"
import script from "./order-pack.vue?vue&type=script&lang=js"
export * from "./order-pack.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports